<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 103 165"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.9352 5.2455C16.7912 1.31578 23.6765 0 28.4998 0V5.5V11C25.3231 11 20.7085 11.9342 17.0646 14.3795C13.7005 16.637 11 20.2412 11 26.5C11 31.0268 11.0222 38.6768 11.0494 48.0529C11.1083 68.3376 11.1905 96.7017 11.1223 119H90.97C90.9705 119 90.9707 119 90.9707 124.5C90.9707 130 90.9705 130 90.97 130H11.0722C11.0527 133.066 11.0289 135.926 11 138.529C11.0049 142.23 11.9513 146.009 14.0841 148.739C16.0404 151.243 19.4766 153.5 26 153.5H76.5671L76.6341 153.502C79.3339 153.567 83.367 152.935 86.5168 151.076C89.3462 149.406 91.5 146.796 91.5 142H102.5C102.5 151.204 97.8204 157.177 92.1082 160.549C86.7472 163.713 80.5704 164.589 76.437 164.5H26C16.5234 164.5 9.70957 161.007 5.41585 155.511C1.30424 150.248 0 143.79 0 138.5V138.469L0.000339508 138.439C0.247029 116.237 0.127948 75.1857 0.0497084 48.2142C0.0223641 38.7878 8.58312e-06 31.0811 0 26.5C-1.85966e-05 16.2588 4.79937 9.36298 10.9352 5.2455ZM91.5 26.5129C91.4877 24.0558 90.3111 19.9648 87.6788 16.5379C85.1641 13.2641 81.6633 11 76.9998 11H28.501C28.5008 11 28.4998 11 28.4998 5.5C28.4998 0 28.4996 0 28.4998 0H76.9998C85.8073 0 92.2919 4.48591 96.4023 9.83712C100.392 15.0312 102.48 21.4347 102.5 26.4785L102.5 26.4893V102C102.5 105.038 100.038 107.5 97 107.5C93.9624 107.5 91.5 105.038 91.5 102V26.5129Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M91.4707 130.5C91.4707 130.224 91.2468 130 90.9707 130V119C97.322 119 102.471 124.149 102.471 130.5V143H91.4707V130.5Z"
      :fill="color"
    />
    <path
      d="M57.4707 141.5C57.4707 144.814 54.7844 147.5 51.4707 147.5C48.157 147.5 45.4707 144.814 45.4707 141.5C45.4707 138.186 48.157 135.5 51.4707 135.5C54.7844 135.5 57.4707 138.186 57.4707 141.5Z"
      :fill="secondaryColor"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#E10E1C",
    },
    secondaryColor: {
      type: String,
      default: "#FBBB21",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
